export default {
    NONE: 0,
    E_COMMERCE: 1,
    SOFTWARE_AS_A_SERVICE: 2,
    SUBSCRIPTION_SERVICE: 3,
}